module.exports = __webpack_public_path__ + "img/Transverse Cracking_moderate severity.4e449732.jpg";